import { Module } from 'vuex';
import { IRootState } from '@types';

import Env from '@lib/Env';

import { AStatisticsApi } from '@/api';

const store: Module<any, IRootState> = {
    state: {
        project_count_last_month: 0,
        customer: {},
        project_list_last_month: [],
        customers: [],
    },

    mutations: {
        setProjectCountLastMonth: (state, count: number) => (state.project_count_last_month = count),
        setLastMonthProjectList: (state, records: any) => (state.project_list_last_month = records),
        setCustomers: (state, records: any) => (state.customers = records),
        setEmptySelectedCustomer: (state) => (state.customer = {}),

        showCustomerProjects: (state, customer_id: number) => {
            const index = state.customers.findIndex((customer: any) => customer_id == customer.id);

            if (index >= 0) {
                state.customer = state.customers[index];
                state.project_list_last_month = state.customers[index].list;
            }
        },
    },

    getters: {
        getProjectCountLastMonth: (state): number => state.project_count_last_month,
        getLastMonthProjectList: (state): any => state.project_list_last_month,
        getCustomers: (state): any => state.customers,
        getSelectedCustomer: (state): any => state.customer,
    },

    actions: {
        loadStatistics({ commit, getters }): Promise<any> {
            return new Promise((resolve, reject) => {
                AStatisticsApi.loadStatistics()
                    .then((response: any) => {
                        if (response.data) {
                            if (response.data.project_count_last_month) {
                                commit('setProjectCountLastMonth', response.data.project_count_last_month);
                            }
                        }

                        resolve(response.status);
                    })
                    .catch((err: any) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        loadLastMonthProjectList({ commit }): Promise<any> {
            return new Promise((resolve, reject) => {
                AStatisticsApi.loadLastMonthProjectList()
                    .then((response: any) => {
                        if (response.data) {
                            if (response.data.status) {
                                commit('setLastMonthProjectList', response.data.records);
                            }
                        }

                        resolve(response.data && response.data.status);
                    })
                    .catch((err: any) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        // CUSTOMER

        loadCustomerStatistics({ commit, getters }): Promise<any> {
            return new Promise((resolve, reject) => {
                AStatisticsApi.loadCustomerStatistics()
                    .then((response: any) => {
                        if (response.data) {
                            if (response.data.status) {
                                commit('setCustomers', response.data.records);
                            }
                        }

                        resolve(response.status);
                    })
                    .catch((err: any) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },
    },
};

export default store;
